var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "item-two-uploader"
  }, [_vm.title ? _c('ItemTitle', {
    attrs: {
      "title": _vm.title,
      "titleHint": _vm.titleHint
    }
  }) : _vm._e(), _c('div', {
    staticClass: "code-wrap clearfix"
  }, [_c('div', {
    staticClass: "code-item fl"
  }, [_c('SingleUploader', {
    ref: "group",
    attrs: {
      "mode": _vm.mode,
      "uploader-class": ['code'],
      "remove-class": ['text-large'],
      "blank": !_vm.isValiate
    },
    on: {
      "add": function add($event) {
        return _vm.onAdd(0, $event);
      },
      "remove": function remove($event) {
        return _vm.onRemove(0);
      },
      "load": _vm.onLoad,
      "finish": _vm.onFinish
    }
  }), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.uploadHint[0]))])], 1), _c('div', {
    staticClass: "code-item fr text-right"
  }, [_c('SingleUploader', {
    ref: "monitor",
    attrs: {
      "mode": _vm.mode,
      "uploader-class": ['code'],
      "remove-class": ['text-large'],
      "blank": !_vm.isValiate
    },
    on: {
      "add": function add($event) {
        return _vm.onAdd(1, $event);
      },
      "remove": function remove($event) {
        return _vm.onRemove(1);
      },
      "load": _vm.onLoad,
      "finish": _vm.onFinish
    }
  }), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.uploadHint[1]))])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };